export default __webpack_public_path__ + "static/media/miguel_osegueda.46249a7b.png";